import React from 'react'

function Home() {
    return (
        <div className='home'>

            <div className="text-box">
                <h1>Déelle</h1>
            </div>
            
        </div>
    )
}

export default Home
